import React from 'react';
import { DefaultMeta } from '../../../../../types/partner-page-types';
import { SimpleCarousal } from '../../../../Atoms/Carousel';
import {
  PartnerNextArrow,
  PartnerPrevArrow,
} from '../../../partner-carousel/utils';
import { PriceCard } from '../../../price_cards/price_cards';
import { IPartnerPlanData } from '../../../types';

interface IPlanCarousal {
  plansData: IPartnerPlanData[];
  metaData: DefaultMeta;
  showPlanFooter?: boolean;
  autoplay?: boolean;
  infinite?: boolean;
  customInfinite?: boolean;
  className?: string;
}

export const PlanCarousal = ({
  plansData,
  metaData,
  showPlanFooter = true,
  autoplay = true,
  infinite = true,
  customInfinite = false,
  className = '',
}: IPlanCarousal): JSX.Element => {
  if (!plansData.length) return <div className="h-[700px]"></div>;
  return (
    <div className={className}>
      <SimpleCarousal
        slidesToShow={3}
        autoplay={autoplay}
        infinite={infinite}
        slidesToScroll={1}
        customArrows={{
          customNextArrow: <PartnerNextArrow variant={'extremeCenter'} />,
          customPrevArrow: <PartnerPrevArrow variant={'extremeCenter'} />,
        }}
        mobile={{
          slidesToShow: 1.1,
          dots: false,
          infinite: true,
        }}
        arrows={true}
        dots={false}
        dotsClass="slick-dash"
        customInfinite={customInfinite}
      >
        {plansData.map((item, idx) => {
          if (!item.planDetails)
            return <React.Fragment key={idx}></React.Fragment>;
          return (
            <PriceCard
              key={`${item.planDetails.planId}_${idx}`}
              cardData={item}
              metaData={metaData}
              showPlanFooter={showPlanFooter}
            />
          );
        })}
      </SimpleCarousal>
    </div>
  );
};
